export function evalHints(hints, value) {
  if (!hints) return [];
  return hints.map(hint => ({
    ...hint,
    status: value ? (hint.check(value) ? 'valid' : 'invalid') : 'unchecked',
  }));
}
